import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "../../shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { useTaskTypeFilter } from "./useTaskTypeFilter";
import { useGroupLocationsFilter } from "./useGroupLocationsFilter";
import { usePeriodFilter } from "./usePeriodFilter";
import { useAssigneeOrCreatorFilter } from "./useAssigneeOrCreatorFilter";
import {
  useMyTeam,
  useStoreTeams,
} from "@coworker/app/src/core/hooks/useStoreTeams";
import { useSortByFilter } from "./useSortByFilter";
import { usePriorityOnlyFilter } from "./usePriorityOnlyFilter";
import { useMyOrTeamTasksFilter } from "./useMyOrTeamTasksFilter";
import { FilterValue } from "../../shared/filters/types/filter";
import { useGroupByFilter } from "./useGroupByFilter";
import { useQuantityTypeFilter } from "./useQuantityTypeFilter";
import { useUID } from "@coworker/app/src/core/auth/useLoggedInUser";

export function useTasksFilters() {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.ACTIVITY_FILTERS
  );

  const uid = useUID();
  const teams = useStoreTeams();
  const myTeam = useMyTeam();

  const useActivityDataFilters = (values: FilterValue[]) => [
    useMyOrTeamTasksFilter("myTasks", uid, "myString", values),
    useMyOrTeamTasksFilter(
      "teamTasks",
      myTeam?.id ?? "",
      "teamTasksString",
      values
    ),
    useAssigneeOrCreatorFilter(
      "assignedTo",
      uid,
      "assignedToTaskFilterString",
      teams
    ),
    useAssigneeOrCreatorFilter("createdBy", uid, "createdByString", teams),
    usePriorityOnlyFilter(),
    useTaskTypeFilter(),
    useGroupByFilter(values),
    useQuantityTypeFilter(values),
    useGroupLocationsFilter(values),
    usePeriodFilter(),
    useSortByFilter(values),
  ];

  const resetFilters = () => {
    setFilterValues([]);
  };

  return {
    useFiltersFactory: useActivityDataFilters,
    filterValues,
    setFilterValues,
    resetFilters,
  };
}
